const { QueryClient } = require('react-query');

const queryClients = {
  rootQueryClient: new QueryClient(),
};

export default queryClients;
